import logo from './logo.svg';

import './App.css';
import Navbar from './Components\'/Navbar';
import MainBar from './Components\'/MainBar';

function App() {
  return (
    <div className="App">
      <div className='container-fluid'>
     <Navbar/>

     <MainBar/>
     </div>
    </div>
  );
}

export default App;
